
    import {useStore} from "@/store";
    import checkItem from './checkItem/checkItem.vue';
    import {defineComponent, computed, ComputedRef, watch, reactive} from "vue";

    interface State {
        dataList: object[];
        tocOnlyShowFlaw: boolean;
        queryModules: object[];
        batteryData: object;
    }
    export default defineComponent({
        name: 'checkCont',
        setup() {
            let state: State = reactive({
                dataList: [],
                tocOnlyShowFlaw: false,
                queryModules: [],
                batteryData: {}
            });
            let store = useStore()
            let dataInfo: ComputedRef<{}> = computed<{}>(() => store.state.dataInfo)
            watch(dataInfo, (data: any) => {
                const {checkItemModules,queryModules, checkModules} = data;
                state.dataList = checkItemModules;
                for (let i=0;i<checkModules.length;i+=1) {
                    let item = checkModules[i];
                    if (item.code === 'KABatteryInfo') {
                        state.batteryData = item;
                        break;
                    }
                }
                console.log(state.dataList);
                if (queryModules && queryModules.length) {
                    let querys = [...queryModules];
                    state.queryModules = querys || [];
                } else {
                    state.queryModules = [];
                }
            })
            let tocOnlyShowFlawS: ComputedRef<{}> = computed<{}>(() => store.state.tocOnlyShowFlaw)
            watch(tocOnlyShowFlawS, (data: any) => {
                // console.log('checkCont:tocOnlyShowFlaw:', data);
                state.tocOnlyShowFlaw = data;
            }, {immediate: true})
            //  {immediate: false}
            function goToView(item: any) {
                console.log('goToView');
                console.log(item);
                window.location.href=(item && item.reportUrl) || '';
            }
            return {
                state,
                goToView
            }
        },
        components: {
            checkItem
        }
    })
